import React, { useEffect, useRef, useState } from 'react'
import Moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import { GetClienteContactos, GetClientes, GetClientesID, GetCotizacionArea, GetCotizaciones, GetCotizacionID, GetProductos, GetUsuarios } from '../components/queries/Queries';
import { createClienteContactos, createCotizacion, createCotizacionArea, createCotizacionUltimoNumero, createNotificaciones, createNotificacionesNuevas, updateCotizacion, updateCotizacionArea, updateCotizacionUltimoNumero } from '../graphql/mutations';
//import { Storage } from 'aws-amplify';
import { getUrl, list, uploadData } from "@aws-amplify/storage";
import { listCotizacionUltimoNumeros } from '../graphql/queries';
import { actualizarClientes, guardarCliente, guardarProductos } from '../components/queries/Mutations';
import { generateClient } from "aws-amplify/api";

const API = generateClient();
const initialfFormState = { formType: 'Cotización' }

const initialFormState = {
    date: '', status: 'Created', generator: '', revision: '', processEngineering: 'Both',//Moment(new Date()).format("YYYY-MM-DD")
    clienteID: '', cliente: '', requestor: '', position: '', desk: '', mobile: '', divisa: 'Dólar',
    address: '', colonia: "", ciudad: "", estado: "", pais: "", codigoPostal: "", telefono: "",
    correo: "", email: '', OEM: '', automotive: '', RFQNumber: '', numerodeParte: '',
    descripcion: '', annualVolume: '', nickName: '', packigType: 'Bulk', packingINumber: '',
    packingIRevision: '', packingSource: '', sampleReceived: '', drawingSProvided: '',
    drawingRevision: '', paintThickness: '', paintSpec: '', zincPlating: '',
    chromateColor: '', previousProcess: '', whiteCRequirement: '', RedCRequiremen: '',
    SOP: '', EOP: '', area: '', pieceWeight: '', printNotes: '', salesNotes: '',
    hangingTool: '', asignedToolBar: '', rackType: '', piecesperBar: '', barsPerLevel: '',
    levels: '', piecesPerRack: '', weightForRack: '', totalPerRack: '', toolingCost: '',
    maximumPieces: '', newToolRequired: '', costOfNewTool: '', totalWeightRack: '', asignedVoltage: '',
    asignedVoltage: '', suggestedRack: '', finalRackSale: '', processSuggestedPrice: '',
    finalSalePrice: '', finalSQFTPrice: '', typeOfProcess: '', hangingToolP: '',
    firstRowDistance: '', tPiecesPROB: '', pPerlevel: '', lPerRack: '', toolAngle: '',
    toolingCostP: '', SQTFPerBR: '', loadWeightK: '', DCVoltageA: '', DCAmperageA: '',
    residenceTimeZinc: '', residenceTimeChromate: '', suggestedRBSale: '',
    finalRBSale: '', processPSuggestedPrice: '', finalPSalePrice: '', SQFTPPrice: '',
    finalPSQFTPrice: '', PPAPLevel: '', aPPAPSubmission: '', aSpecRessumission: '',
    exsistingFamilly: '', pointsToQuality: '', qualityNotes: '',
    activo: true, Reg_Ins_Usuario: '', Reg_Mod_Usuario: ''
}

export default function useCotizaciones() {
    //Declaración de variables    
    const initialArea = { alto: "", ancho: "", medidaGrosor: "No", activo: true, repeticiones: 1 }
    const [clientes, setClientes] = useState([]);
    const [reciba, setReciba] = useState([]);
    const [recibaSinFiltro, setRecibaSinFiltro] = useState([]);
    const [embarquesSinFiltro, setEmbarquesSinFiltro] = useState([]);
    const [cotizaciones, setCotizaciones] = useState([]);
    const [cotizacionImprimir, setCotizacionImprimir] = useState([]);
    const [embarqueEliminar, setEmbarqueEliminar] = useState([]);
    const [editar, setEditar] = useState(false);
    const [formData, updateFormData] = useState(initialFormState);
    const [editarCliente, setEditarCliente] = useState(false);
    const [editarContacto, setEditarContacto] = useState(false);
    const [editarPprocess, setEditarPprocess] = useState(false);
    const [editarAToolBar, setEditarAToolBar] = useState(false);
    const [clienteNuevo, setClienteNuevo] = useState(false);
    const [contactoNuevo, setContactoNuevo] = useState(false);
    const [productoNuevo, setProductoNuevo] = useState(false);
    const [ultimoNumeroP, setultimoNumeroP] = useState(0);
    const [formState, updateFormState] = useState(initialfFormState);
    const [isDisabled, setisDisabled] = useState(false);
    const [buscarporFecha, setBuscarporFecha] = useState(true);
    const [estadoReciba, setEstadoReciba] = useState("todos");
    const [search, setSearch] = useState("");
    const [fechaPBusqueda, setFechaPBusqueda] = useState("");
    const [searchBy, setSearchBy] = useState("cliente");
    const [searchReciba, setSearchReciba] = useState("");
    const [searchByReciba, setSearchByReciba] = useState("cliente");
    const [totalRecords, setTotalRecords] = useState(0);
    const { formType } = formState;
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [tituloTab, setTituloTab] = useState("Generar cotización");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const pcotizaciones = window.$Cotizaciones ? window.$Cotizaciones : false;
    const [permisoAutorizar, setPermisoAutorizar] = useState(false);
    const [hEditarCotizacion, setHEditarCotizacion] = useState(false);
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [clienteID, setClienteID] = useState("");
    const [aMRecuperado, setAMRecuperado] = useState(false);
    const [quoteNumberO, setQuoteNumberO] = useState("");
    const [statusOriginal, setStatusOriginal] = useState("");
    const onDismiss = () => setAVisible(false);
    const [inputList, setInputList] = useState([initialArea]);
    const [inputListMod, setInputListMod] = useState([]);
    const [cotizacionesRechazadas, setCotizacionesRechazadas] = useState([]);
    const [medidaIngresadaEn, setMedidaIngresadaEn] = useState("Milímetros");
    const [requestors, setRequestors] = useState([]);
    const [activeTab, setActiveTab] = useState('1');
    const [paginas, setPaginas] = useState([]);
    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [modal3, setModal3] = useState(false);
    const [faltanDatos, setFaltanDatos] = useState(false);
    const [DocumentoRepetido, setDocumentoRepetido] = useState(false);
    const [archivo, setArchivo] = useState({});
    const [mensajeAlertM, setMensajeAlertM] = useState("");
    const [colorM, setColorM] = useState("warning");
    const [aVisibleM, setAVisibleM] = useState(false);
    const [cargandoM, setCargandoM] = useState(false);
    const [documenton, setDocumenton] = useState(1);
    Moment.locale('en');
    var now = new Date();
    var now2 = new Date();
    now2.setMonth(now2.getMonth() - 1);
    now.setDate(now.getDate() + 5);
    const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
    const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));



    const toggle1 = tab => {
        if (activeTab !== tab) setActiveTab(tab);
        if (tab > 1) setAVisible(false);
    }

    const toggle = () => setModal(!modal);
    const toggle2 = () => setModal2(!modal2);
    const toggle3 = () => setModal3(!modal3);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    // current page
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageCotizaciones, setCurrentPageEmbarques] = useState(1);

    // total records per page to display
    const recordPerPage = 20;
    const recordPerPageCotizacion = 20;

    // range of pages in paginator
    const pageRange = 5;

    // handle change event
    function handlePageChange(pageNumber) {
        setAVisible(false);
        setCargando(false)
        setCurrentPage(pageNumber);
        busqueda(recibaSinFiltro, estadoReciba, searchByReciba, searchReciba, pageNumber);
    }

    // handle change event
    function handlePageChangeCotizaciones(pageNumber) {
        setAVisible(false);
        setCargando(false);
        setCurrentPageEmbarques(pageNumber);
        busquedaCotizacion(embarquesSinFiltro, searchBy, search, pageNumber, fechaPBusqueda);
    }

    async function busquedaCotizacion(cotizacionessf, searchb, search, currentPage) {
        var paginasp = [];
        var p = 1;
        var pi = 1;

        const cotizacionesFromAPI = cotizacionessf.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0).filter(cotizacion =>
                searchb === "numero de parte" ? cotizacion.numerodeParte.toLowerCase().includes(search.toLowerCase()) :
                    searchb === "cliente" ? cotizacion.cliente.toLowerCase().includes(search.toLowerCase()) :
                        searchb === "id de cotizacion" ? cotizacion.quoteNumber.toLowerCase().includes(search.toLowerCase()) :
                            Moment(cotizacion.date).format("DD/MM/YYYY").includes(Moment(search).format("DD/MM/YYYY")));

        await Promise.all(cotizacionesFromAPI.map(async cotizaciones => {
            cotizaciones.paginacion = pi;
            p++;
            if (p > recordPerPageCotizacion) {
                p = 1;
                paginasp.push({ pagina: pi });
                pi++;
            }
            return cotizaciones;
        }));

        const lengthCotizacion = cotizacionesFromAPI.length;
        if (lengthCotizacion <= 0)
            setCurrentPageEmbarques(1);

        const cotizacionF = cotizacionesFromAPI.filter(cotizaciones => cotizaciones.paginacion === currentPage).sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0);
        setCotizaciones(cotizacionF);

        const prepaginas = parseInt(lengthCotizacion / recordPerPageCotizacion);
        const paginas = prepaginas * recordPerPageCotizacion < lengthCotizacion ? prepaginas + 1 : prepaginas;
        if (paginas > paginasp.length)
            paginasp.push({ pagina: paginas })

        if (currentPage > 1 && lengthCotizacion > 0) {
            if (currentPage > paginas) {
                setCurrentPageEmbarques(paginas);
            }
        }

        if (lengthCotizacion > 0) {
            setPaginas(paginasp);
            setultimoNumeroP(paginasp[paginasp.length - 1].pagina)
        } else {
            setPaginas([]);
            setultimoNumeroP(0)
        }
        setCargando(false);
    }
    async function busqueda(recibasinf, estadoReciba, searchb, search, currentPage) {
        var pag = 1;
        var bandera = 1;
        //Filtrado de datos por la búsqueda y el estado de reciba
        const recibaFromAPI = recibasinf.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0).filter(reciba => parseInt(reciba.piezasEmbarcadas) != parseInt(reciba.piezasAEmbarcar) || !reciba.piezasEmbarcadas).filter(reciba =>
                estadoReciba === "todos" ? reciba.status === reciba.status : reciba.status === estadoReciba).filter(reciba =>
                    searchb === "numero de parte" ? reciba.numerodeParte.toLowerCase().includes(search.toLowerCase()) :
                        searchb === "cliente" ? reciba.cliente.toLowerCase().includes(search.toLowerCase()) :
                            searchb === "clienteID" ? aMRecuperado ? reciba.clienteID.toLowerCase().includes(search.toLowerCase()) &&
                                reciba.piezasAEmbarcar > 0 : reciba.clienteID.toLowerCase().includes(search.toLowerCase()) && reciba.piezasPintadas > 0 :
                                searchb === "id de reciba" ? reciba.numero.toLowerCase().includes(search.toLowerCase()) :
                                    searchb === "serial" ? reciba.serial.toLowerCase().includes(search.toLowerCase()) :
                                        searchb === "paking" ? reciba.packing.toLowerCase().includes(search.toLowerCase()) :
                                            searchb === 'lote' ? reciba.lote.toLowerCase().includes(search.toLowerCase()) :
                                                searchb === 'aMRecuperado' ? search ? reciba.piezasAEmbarcar > 0 &&
                                                    reciba.clienteID.toLowerCase().includes(clienteID.toLowerCase()) : reciba.piezasPintadas > 0
                                                && reciba.clienteID.toLowerCase().includes(clienteID.toLowerCase()) :
                                                    reciba.fechayHoraDeReciba.includes(Moment(search).format("DD/MM/YYYY")));



        await Promise.all(recibaFromAPI.map(async (reciba, i) => {
            reciba.indexpag = pag;
            bandera++;
            if (bandera > recordPerPage) {
                bandera = 1;
                pag++;
            }
            return reciba;
        }))



        const lengthreciba = recibaFromAPI.length;
        if (lengthreciba <= 0)
            setCurrentPage(1);

        setReciba(recibaFromAPI.filter(reciba => reciba.indexpag === currentPage).sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0));
        setTotalRecords(lengthreciba);

        if (currentPage > 1 && lengthreciba > 0) {
            const prepaginas = parseInt(lengthreciba / recordPerPage);
            const paginas = prepaginas * recordPerPage < lengthreciba ? prepaginas + 1 : prepaginas;
            if (currentPage > paginas) {
                setCurrentPage(paginas);
                const recibaFromAPIp = recibaFromAPI.sort((a, b) =>
                    a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0).filter(reciba =>
                        reciba.indexpag === paginas);
                setReciba(recibaFromAPIp.sort((a, b) =>
                    a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0));
            }
        }
    }
    //Método useEffect
    useEffect(() => {
        fetchCotizaciones(rfechaini, rfechafin);
        fetchClientes();
    }, []);

    //Obtiene el nombre de usuario del usuario logueado
    async function fetchUsuario() {
        //Filtro por planeación activa        
        let filter = {
            usuario: {
                eq: userName
            }
        }
        const apiData = await GetUsuarios(filter);
        const dataFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        if (dataFromAPI[0])
            setPermisoAutorizar(dataFromAPI[0].CotizacionesAutorizar);
    }
    //Obtiene los datos guardados de los clientes
    async function fetchClientes() {
        const apiData = await GetClientes();
        const clientesFromAPI = apiData;
        await Promise.all(clientesFromAPI.map(async (cliente, i) => {
            if (cliente.image) {
                const image = await getUrl({ key: cliente.image });//await Storage.get(cliente.image);
                cliente.image = image.url.toString();
            }
            return cliente;
        }))
        setClientes(apiData);
    }
    //Obtiene los datos guardados de las planeaciones
    async function fetchCotizaciones(fechainicial, fechafinal) {
        //Filtro por planeación activa
        setCargando(true);
        fetchUsuario();
        let filter = {
            and: [{
                activo: {
                    eq: true
                }
            },
            {
                date: {
                    ge: fechainicial
                }
            },
            {
                date: {
                    le: fechafinal
                }
            }]
        }
        //Se obtienen los datos de la cotización
        const apiData = await GetCotizaciones(filter);
        //Se ordenan los datos de la cotización por número. 
        const CotizacionesFromAPI = await apiData.sort((a, b) =>
            a.numero < b.numero ? 1 : a.numero > b.numero ? -1 : 0);
        const cotizacionesRechaz = await GetCotizaciones({ and: [{ activo: { eq: true } }, { status: { eq: "Rejected" } }] });
        setCotizacionesRechazadas(cotizacionesRechaz);
        setEmbarquesSinFiltro(CotizacionesFromAPI);
        busquedaCotizacion(CotizacionesFromAPI, searchBy, search, currentPageCotizaciones);


    }
    function buscarpor(e) {
        setAVisible(false);
        setSearchBy(e.target.value);
        if (search && e.target.value !== "fecha")
            busquedaCotizacion(embarquesSinFiltro, e.target.value, search, currentPageCotizaciones);
    };
    function onSearch(e) {
        setAVisible(false);
        busquedaCotizacion(embarquesSinFiltro, searchBy, search, currentPageCotizaciones);
    };
    function onSearchFecha(e) {
        setAVisible(false);
        setSearch(e.target.value);
        busquedaCotizacion(embarquesSinFiltro, searchBy, e.target.value, currentPageCotizaciones);
    };
    // handle input change  
    function clicEliminar(embarque) {
        setEmbarqueEliminar(embarque);
        setModal(!modal)
    };

    function cancelarModalCotizacion() {
        toggle2();
        cancelarCotizacion();
    };
    function cancelarCotizacion() {
        setAVisibleM(false);
        setCargandoM(false);
        setDocumentoRepetido(false);
        fetchCotizaciones(rfechaini, rfechafin);
        setEditar(false);
        setFaltanDatos(false);
        updateFormData(initialFormState);
        setRequestors([]);
        setClienteID("");
        toggle1('1');
        setTituloTab("Generar cotización");
    };
    async function clicAutorizar() {
        window.scrollTo(0, 0);
        formData.autorizado = true;
        formData.status = "Authorized";
        manageCotizacion();

    };
    async function clicAgregarCotizacion(cotizacion) {
        setAVisible(false);
        setCargando(false);
        //Obtención de contactos
        setEditarCliente(!cotizacion.clienteCatalogo);
        setHEditarCotizacion(false);
        setEditarContacto(!cotizacion.clienteNContacto);
        setEditarPprocess(false);
        setEditarAToolBar(false);
        const ClienteDato = clientes.filter(dCliente => dCliente.id === cotizacion.clienteID)
        var contactos = [];
        if (ClienteDato[0].nombreContacto) {
            contactos.push({
                requestor: ClienteDato[0].nombreContacto, position: ClienteDato[0].puestoContacto, desk: ClienteDato[0].telefono,
                mobile: ClienteDato[0].telefonoContacto, email: ClienteDato[0].correoContacto
            });
        }
        if (ClienteDato[0].nombreContacto1) {
            contactos.push({
                requestor: ClienteDato[0].nombreContacto1, position: ClienteDato[0].puestoContacto1, desk: ClienteDato[0].telefono1,
                mobile: ClienteDato[0].telefonoContacto1, email: ClienteDato[0].correoContacto1
            });
        }
        if (ClienteDato[0].nombreContacto2) {
            contactos.push({
                requestor: ClienteDato[0].nombreContacto2, position: ClienteDato[0].puestoContacto2, desk: ClienteDato[0].telefono2,
                mobile: ClienteDato[0].telefonoContacto2, email: ClienteDato[0].correoContacto2
            });
        }
        if (ClienteDato[0].nombreContacto3) {
            contactos.push({
                requestor: ClienteDato[0].nombreContacto3, position: ClienteDato[0].puestoContacto3, desk: ClienteDato[0].telefono3,
                mobile: ClienteDato[0].telefonoContacto3, email: ClienteDato[0].correoContacto3
            });
        }
        if (ClienteDato[0].nombreContacto4) {
            contactos.push({
                requestor: ClienteDato[0].nombreContacto4, position: ClienteDato[0].puestoContacto4, desk: ClienteDato[0].telefono4,
                mobile: ClienteDato[0].telefonoContacto4, email: ClienteDato[0].correoContacto4
            });
        }
        if (contactos.length >= 5) {
            const contactosc = await GetClienteContactos({ clienteID: { eq: cotizacion.clienteID } });
            await Promise.all(contactosc.map(async contacto => {
                contactos.push({
                    requestor: contacto.nombreContacto, position: contacto.puestoContacto, desk: contacto.telefono,
                    mobile: contacto.telefonoContacto, email: contacto.correoContacto
                });
            }))
        }
        setRequestors(contactos);
        //Asignación de los datos de la cotización
        cotizacion.CotizacionPadreID = cotizacion.id;
        cotizacion.revision = cotizacion.revision === "A" ? "B" : cotizacion.revision === "B" ? "C" : cotizacion.revision === "C" ? "D" :
            cotizacion.revision === "D" ? "E" : cotizacion.revision === "E" ? "F" : cotizacion.revision === "F" ? "G" : cotizacion.revision === "G" ? "H" :
                cotizacion.revision === "H" ? "I" : cotizacion.revision === "I" ? "J" : cotizacion.revision === "J" ? "K" : "";
        cotizacion.Reg_Ins_Usuario = userName;
        cotizacion.status = "Created";
        delete cotizacion.productoCreado;
        delete cotizacion.productoID;
        delete cotizacion.paginacion;
        delete cotizacion.numero;
        delete cotizacion.quoteNumber;
        delete cotizacion.updatedAt;
        delete cotizacion.__typename;
        delete cotizacion.createdAt;
        delete cotizacion.id;
        delete cotizacion.date;
        delete cotizacion.Reg_Mod_Usuario;
        updateFormData(cotizacion);

        //Asignación de datos necesarios para la operación
        setEditar(false);
        setisDisabled(false);
        setTituloTab("Generar cotización")
        toggle1("3");

    };
    async function actualizarStatusCotizacion(cotizacion, operacion) {
        setAVisible(false);
        setCargando(true);
        //Inicio de la operación
        const bcotizacion = await GetCotizacionID(cotizacion.id);
        if (bcotizacion.length <= 0 || bcotizacion.updatedAt != cotizacion.updatedAt) {
            setAVisible(true);
            setCargando(false);
            setMensajeAlert("Existe concurrencia, favor de reintentar la operación.");
        } else {
            cotizacion.Reg_Mod_Usuario = userName;
            delete cotizacion.createdAt
            delete cotizacion.updatedAt;
            delete cotizacion.__typename;
            delete cotizacion.paginacion;
            setMensajeAlert("Error al actualizar la cotización " + JSON.stringify(cotizacion));
            // Se crea una notificación del cambio de estatus
            await API.graphql({ query: updateCotizacion, variables: { input: cotizacion } });
            const notificaciones = {
                modulo: "Cotizaciones",
                Accion: "Cambio de estatus de la cotización a: " + cotizacion.status,
                notificacion: "El estatus de la cotización " + cotizacion.quoteNumber + " del cliente " + cotizacion.cliente + " ha cambiado a: " + cotizacion.status,
                fecha: Moment(new Date()).format("YYYY-MM-DD"),
                hora: Moment(new Date()).format("HH:mm"),
                leido: false,
                usuarioDe: userName,
                paraSoporte: false,
                activo: true,
                Reg_Ins_Usuario: userName
            };
            //Se guardan los datos de la notificación.
            //setMensajeAlert("Error al guardar la notificación general " + JSON.stringify(notificaciones));
            let resultnot = await API.graphql({ query: createNotificaciones, variables: { input: notificaciones } });
            //Se crea un registro en la tabla de NotificacionesNuevas para cada uno de los usuarios de soporte
            notificaciones.NotificacionID = resultnot.data.createNotificaciones.id;
            const usuariosNot = await GetUsuarios({
                and: [{ activo: { eq: true } }, { Notificaciones: { eq: true } }, { usuario: { ne: userName.toUpperCase() } }, { Cotizaciones: { eq: true } }]
            })
            await Promise.all(
                usuariosNot.map(async (not, i) => {
                    const notific = { ...notificaciones, usuarioPara: not.usuario };
                    //Se establece para qué usuario es la notificación                    
                    //setMensajeAlert("Error al guardar la notificación nueva " + JSON.stringify(notific));
                    await API.graphql({ query: createNotificacionesNuevas, variables: { input: notific } });
                })
            );
        }
        if (operacion === 1) {//Actualización de estatus a enviado
            setMensajeAlert("Operación exitosa,se actualizó el status a  enviado del Quote Number: " + cotizacion.quoteNumber + "");
        }
        if (operacion === 2) {//Actualización de estatus a rechazado
            setMensajeAlert("Operación exitosa,se actualizó el status a  rechazado del Quote Number: " + cotizacion.quoteNumber + " y se registró el comentario de rechazo");
            toggle3();
        }
        setColor("primary");

        setAVisible(true);
        setCargando(false);
        fetchCotizaciones(rfechaini, rfechafin);
    };

    async function clicEditar(cotizacion) {
        await prepararDatos(cotizacion)
        setHEditarCotizacion((cotizacion.status === "Created" || cotizacion.status === "Rejected") ? false : true);
        setisDisabled(false);
        setTituloTab("Editar cotización")
        toggle1("3");

    };
    async function clicMostrar(cotizacion) {
        await prepararDatos(cotizacion)
        setHEditarCotizacion(true);
        setTituloTab("Detalle de cotización");
        toggle1("3");
    };
    async function prepararDatos(cotizacion) {
        setAVisible(false);
        setCargando(false);
        setStatusOriginal(cotizacion.status);
        setEditarCliente(!cotizacion.clienteCatalogo);
        setEditarContacto(cotizacion.clienteNContacto);
        setEditarPprocess(false);
        setEditarAToolBar(false);
        /*if (cotizacion.image) {
            ObtenerDocumento(cotizacion.image, "fimage");
        }*/
        cambioClientes(cotizacion.clienteID, cotizacion, true);
        if (cotizacion.documentoAceptacion) {
            const archivo = await getUrl({ key: cotizacion.documentoAceptacion });//await Storage.get(cotizacion.documentoAceptacion);
            setArchivo(archivo.url.toString())
        }
        var documentos = 1;
        if (cotizacion.image) {
            const fimagen = await getUrl({ key: cotizacion.image });//await Storage.get(cotizacion.image);
            cotizacion.imageurl = fimagen.url.toString();
        }
        if (cotizacion.documento1) {
            const fdocumento = await getUrl({ key: cotizacion.documento1 });//await Storage.get(cotizacion.documento1);
            cotizacion.documento1url = fdocumento.url.toString();
        }
        if (cotizacion.documento2) {
            const fdocumento = await getUrl({ key: cotizacion.documento2 });//await Storage.get(cotizacion.documento2);
            cotizacion.documento2url = fdocumento.url.toString();
            documentos = 2;
        }
        if (cotizacion.documento3) {
            const fdocumento = await getUrl({ key: cotizacion.documento3 });//await Storage.get(cotizacion.documento3);
            cotizacion.documento3url = fdocumento.url.toString();
            documentos = 3;
        }
        if (cotizacion.documento4) {
            const fdocumento = await getUrl({ key: cotizacion.documento4 });//await Storage.get(cotizacion.documento4);
            cotizacion.documento4url = fdocumento.url.toString();
            documentos = 4;
        }
        if (cotizacion.documento5) {
            const fdocumento = await getUrl({ key: cotizacion.documento5 });//await Storage.get(cotizacion.documento5);
            cotizacion.documento5url = fdocumento.url.toString();
            documentos = 5;
        }
        setDocumenton(documentos);
        updateFormData(cotizacion);
        var Area = await (await GetCotizacionArea({ and: [{ idCotizacion: { eq: cotizacion.id } }, { activo: { eq: true } }] })).sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        setInputList([...Area, initialArea]);
        setInputListMod([...Area, initialArea]);
        setMedidaIngresadaEn(Area[0] ? Area[0].medidaIngresadaEn : "Milímetros");
        setEditar(true);
    }
    function clicNuevaCotizacion() {
        setAMRecuperado(false);
        setClienteID("");
        setStatusOriginal("");
        setEditarCliente(false);
        setHEditarCotizacion(false);
        setEditarContacto(false);
        setEditarPprocess(false);
        setEditarAToolBar(false);
        updateFormData(initialFormState);
        setTituloTab("Generar cotización");
        setEditar(false);
        setInputList([initialArea]);
        setMedidaIngresadaEn("Milímetros");
        toggle1('3');
    };
    async function manageCotizacion() {
        setAVisible(false);
        setCargando(true);
        window.scrollTo(0, 0);
        try {
            setMensajeAlert("Iniciando operaciones...");
            var mensaje = "";
            delete formData.archivoname;
            if (!formData.status || !formData.date || !formData.generator || !formData.revision || !formData.processEngineering
                || !formData.cliente || !formData.requestor || !formData.position || !formData.automotive
                || !formData.numerodeParte || !formData.annualVolume || !formData.sampleReceived || !formData.area) {//|| datosCompletos === false
                mensaje = "Faltan datos; los campos marcados con un asterísco son obligatorios. ";// + datosCompletos;
                setFaltanDatos(true);
            }
            if (DocumentoRepetido) {
                mensaje = mensaje + "Ya existe un archivo con el mismo nombre: favor de seleccionar otro archivo o cambiar el nombre del archivo y volver a intentarlo. ";
            }
            //Si el estatus es aceptado, se revisa si ya existe un número de parte activo igual que el que se intenta guardar
            //para el cliente indicado.
            if (formData.status === "Accepted" && !formData.productoCreado) {
                let filter = {
                    and: [{
                        activo: {
                            eq: true
                        }
                    },
                    {
                        clienteID: {
                            eq: formData.clienteID
                        }
                    },
                    {
                        numerodeParte: {
                            eq: formData.numerodeParte
                        }
                    }]
                }
                //Se obtienen los datos de la cotización
                const productos = await GetProductos(filter);
                if (productos.length > 0) {
                    mensaje = "No es posible realizar la operación; Número de parte repetido para el cliente especificado. " +
                        "Para proceder con la operación, se tiene que marcar como inactivo el número de parte en cuestión en el área de Productos";
                }

            }

            setMensajeAlert("Validando datos faltantes..");

            if (mensaje !== "") {
                setMensajeAlert(mensaje);
                setColor("warning");
                setAVisible(true);
                setisDisabled(false);
                setCargando(false);
            } else {
                var numeroUP = 1;
                var quoteNumberUP = quoteNumberO + (numeroUP < 10 ? "00" + numeroUP.toString() :
                    numeroUP < 100 ? "0" + numeroUP.toString() : numeroUP.toString()) + formData.revision;
                setMensajeAlert("Inicial " + editar);
                //Fecha y hora de la operación
                const fechaHora = Moment(new Date()).format("YYYY-MM-DD HH:mm");
                if (!editar) {
                    setMensajeAlert("No editar");

                    const apiData = await API.graphql({ query: listCotizacionUltimoNumeros, variables: { filter: { fecha: { eq: formData.date } }, limit: 100000000 } });
                    const ultimaCFromAPI = apiData.data.listCotizacionUltimoNumeros.items;
                    setMensajeAlert("Obtuve datos");
                    await Promise.all(ultimaCFromAPI.map(async ultimaCotizacionD => {
                        numeroUP = ultimaCotizacionD.numero + 1;
                        quoteNumberUP = quoteNumberO + (numeroUP < 10 ? "00" + numeroUP.toString() :
                            numeroUP < 100 ? "0" + numeroUP.toString() : numeroUP.toString()) + formData.revision;
                        ultimaCotizacionD.numero = numeroUP;
                        ultimaCotizacionD.quoteNumber = quoteNumberUP;
                        delete ultimaCotizacionD.createdAt;
                        delete ultimaCotizacionD.updatedAt;
                        delete ultimaCotizacionD.__typename;
                        ultimaCotizacionD.Reg_Mod_Usuario = userName;
                        setMensajeAlert("Error al acualizar número de la cotización ");
                        await API.graphql({ query: updateCotizacionUltimoNumero, variables: { input: ultimaCotizacionD } })

                        return ultimaCotizacionD;
                    }))
                    if (!ultimaCFromAPI.length) {
                        setMensajeAlert("Error al guardar número de la cotización ");
                        await API.graphql({
                            query: createCotizacionUltimoNumero, variables: {
                                input: {
                                    fecha: formData.date, numero: numeroUP, quoteNumber: quoteNumberUP, activo: true, Reg_Ins_Usuario: userName
                                }
                            }
                        });
                    }
                    //Guarda los datos de la cotización                      
                    if (permisoAutorizar === true) {
                        formData.autorizado = true;
                        formData.status = "Authorized";
                        formData.fechaAutorizado = fechaHora;
                    }
                    formData.fechaCreado = fechaHora;
                    formData.numero = numeroUP;
                    formData.clienteCatalogo = !editarCliente;
                    formData.clienteNContacto = editarContacto;
                    formData.quoteNumber = quoteNumberUP;
                    formData.Reg_Ins_Usuario = userName;
                    formData.divisa = "Dólar";
                    setMensajeAlert("Error al guardar la cotización " + JSON.stringify(formData));
                    let resultadoc = await API.graphql({ query: createCotizacion, variables: { input: formData } });
                    //Datos recién creados.                
                    const cotizacionCreada = resultadoc.data.createCotizacion;
                    //Si existen datos de las dimensiones del área de la pieza, se guardan.
                    await Promise.all(inputList.map(async (medidas, i) => {
                        if (i < inputList.length - 1) {
                            medidas.numero = cotizacionCreada.numero;
                            medidas.idCotizacion = cotizacionCreada.id;
                            medidas.medidaIngresadaEn = medidaIngresadaEn;
                            medidas.orden = i;
                            medidas.Reg_Ins_Usuario = userName;

                            setMensajeAlert("Error al guardar las medidas del área " + JSON.stringify(medidas));
                            await API.graphql({ query: createCotizacionArea, variables: { input: medidas } });
                        }
                    }))
                    setMensajeAlert("Operación exitosa,se créo el Quote Number: " + formData.quoteNumber);
                    setColor("primary");

                    //Se crea una notificación de la creación de una nueva cotización y está pendiente de Autorización.
                    const notificaciones = {
                        modulo: "Cotizaciones",
                        Accion: "Nueva cotización creada",
                        notificacion: "Se ha creado " + (permisoAutorizar ? "y autorizado" : "como pendiente de autorizar") + " la cotización " + quoteNumberUP + " para el cliente " + formData.cliente,
                        fecha: Moment(new Date()).format("YYYY-MM-DD"),
                        hora: Moment(new Date()).format("HH:mm"),
                        leido: false,
                        usuarioDe: userName,
                        paraSoporte: false,
                        activo: true,
                        Reg_Ins_Usuario: userName
                    };
                    //Se guardan los datos de la notificación.
                    //setMensajeAlert("Error al guardar la notificación general " + JSON.stringify(notificaciones));
                    let resultnot = await API.graphql({ query: createNotificaciones, variables: { input: notificaciones } });
                    //Se crea un registro en la tabla de NotificacionesNuevas para cada uno de los usuarios de soporte
                    notificaciones.NotificacionID = resultnot.data.createNotificaciones.id;
                    const usuariosNot = await GetUsuarios({
                        and: [{ activo: { eq: true } }, { Notificaciones: { eq: true } }, { usuario: { ne: userName } }, { CotizacionesAutorizar: { eq: true } }]
                    })
                    await Promise.all(
                        usuariosNot.map(async (not, i) => {
                            const notific = { ...notificaciones, usuarioPara: not.usuario };
                            //Se establece para qué usuario es la notificación                    
                            //setMensajeAlert("Error al guardar la notificación nueva " + JSON.stringify(notific));
                            await API.graphql({ query: createNotificacionesNuevas, variables: { input: notific } });
                        })
                    );
                } else {
                    setColor("warning");
                    const cotizacionID = await GetCotizacionID(formData.id);
                    if (cotizacionID.updatedAt !== formData.updatedAt) {
                        setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y volver a intentarlo");
                        setAVisible(true);
                        setCargando(false);
                        setisDisabled(false);
                        return
                    }
                    setMensajeAlert("Empezando la edición");
                    //Preparando los datos para la actualización.
                    var clienteCreado = false;
                    var contactoAgregado = false;
                    var vproductoCreado = false;
                    formData.clienteCatalogo = !editarCliente;
                    formData.clienteNContacto = editarContacto;
                    if (statusOriginal !== formData.status) {
                        setMensajeAlert("Cambio de estatus");
                        if (formData.status === "Authorized")
                            formData.fechaAutorizado = fechaHora;
                        if (formData.status === "Send")
                            formData.fechaEnviado = fechaHora;
                        if (formData.status === "Waiting")
                            formData.fechaEsperando = fechaHora;
                        if (formData.status === "Accepted")
                            formData.fechaAceptado = fechaHora;
                        if (formData.status === "Rejected")
                            formData.fechaRechazado = fechaHora;
                        //Si el nuevo estatus es aceptado
                        if (formData.status === "Accepted" && !formData.productoCreado) {
                            //Si el cliente es nuevo
                            if (formData.clienteCatalogo === false) {
                                setMensajeAlert("Se intenta la creación del cliente");
                                const cliente = {
                                    cliente: formData.cliente, image: formData.image ? formData.image : "empresaIcono.png", activo: true,
                                    domicilio: formData.address, ciudad: formData.ciudad, Reg_Ins_Usuario: userName,
                                    codigoPostal: formData.codigoPostal, colonia: formData.colonia, estado: formData.estado,
                                    pais: formData.pais, correo: formData.correo, telefono: formData.telefono,
                                    nombreContacto: formData.requestor, telefonoContacto: formData.desk + ", " + formData.mobile,
                                    puestoContacto: formData.position, correoContacto: formData.email, idCotizacion: formData.id
                                }
                                setMensajeAlert("Llamada al método para la creación de cliente: " + JSON.stringify(cliente));
                                const clienteProductoC = await guardarCliente(cliente, false, {}, true);
                                setMensajeAlert("Llamadado: " + JSON.stringify(clienteProductoC));
                                if (clienteProductoC.completo === false) {
                                    setMensajeAlert(clienteProductoC.mensaje);
                                    setColor(clienteProductoC.color);
                                    setAVisible(true);
                                    setCargando(false);
                                    setisDisabled(false);
                                    return
                                }
                                if (clienteProductoC.clienteID !== "") {
                                    formData.clienteID = clienteProductoC.clienteID;
                                    formData.clienteCatalogo = true;
                                    formData.clienteNContacto = false;
                                    clienteCreado = true;
                                }
                                if (clienteProductoC.productoID !== "") {
                                    formData.productoID = clienteProductoC.productoID;
                                    formData.productoCreado = true;
                                    vproductoCreado = true;
                                }
                            } else {//Si no es cliente nuevo 
                                //Si es contacto nuevo, se obtienen los datos del cliente en cuestión, para actualizar los 
                                //datos del contacto.
                                if (formData.clienteNContacto === true) {
                                    if (formData.clienteID !== "") {
                                        const cliente = await GetClientesID(formData.clienteID);
                                        if (!cliente.nombreContacto1) {
                                            cliente.nombreContacto1 = formData.requestor;
                                            cliente.puestoContacto1 = formData.position;
                                            cliente.telefonoContacto1 = formData.desk + ", " + formData.mobile;
                                            cliente.correoContacto1 = formData.email;
                                            cliente.Reg_Mod_Usuario = userName;
                                            const clienteActualizado = await actualizarClientes(cliente, false, {}, {}, true);
                                            if (clienteActualizado.completo === true) {
                                                contactoAgregado = true;
                                            }
                                        } else if (!cliente.nombreContacto2) {
                                            cliente.nombreContacto2 = formData.requestor;
                                            cliente.puestoContacto2 = formData.position;
                                            cliente.telefonoContacto2 = formData.desk + ", " + formData.mobile;
                                            cliente.correoContacto2 = formData.email;
                                            cliente.Reg_Mod_Usuario = userName;
                                            const clienteActualizado = await actualizarClientes(cliente, false, {}, {}, true);
                                            if (clienteActualizado.completo === true) {
                                                contactoAgregado = true;
                                            }
                                        } else if (!cliente.nombreContacto3) {
                                            cliente.nombreContacto3 = formData.requestor;
                                            cliente.puestoContacto3 = formData.position;
                                            cliente.telefonoContacto3 = formData.desk + ", " + formData.mobile;
                                            cliente.correoContacto3 = formData.email;
                                            cliente.Reg_Mod_Usuario = userName;
                                            const clienteActualizado = await actualizarClientes(cliente, false, {}, {}, true);
                                            if (clienteActualizado.completo === true) {
                                                contactoAgregado = true;
                                            }
                                        } else if (!cliente.nombreContacto4) {
                                            cliente.nombreContacto4 = formData.requestor;
                                            cliente.puestoContacto4 = formData.position;
                                            cliente.telefonoContacto4 = formData.desk + ", " + formData.mobile;
                                            cliente.correoContacto4 = formData.email;
                                            cliente.Reg_Mod_Usuario = userName;
                                            const clienteActualizado = await actualizarClientes(cliente, false, {}, {}, true);
                                            if (clienteActualizado.completo === true) {
                                                contactoAgregado = true;
                                            }
                                        } else {
                                            //Se preparan los datos para guardar el contacto
                                            const contacto = {
                                                clienteID: formData.clienteID, nombreContacto: formData.requestor,
                                                telefonoContacto: formData.desk + ", " + formData.mobile,
                                                puestoContacto: formData.position, correoContacto: formData.email,
                                                activo: true, Reg_Ins_Usuario: userName
                                            }
                                            setMensajeAlert("Problemas al guardar el nuevo contacto: " + JSON.stringify(contacto));
                                            let resultadop = await API.graphql({ query: createClienteContactos, variables: { input: contacto } });
                                            contactoAgregado = true;
                                        }

                                    }

                                }
                                //Si existe un ID del cliente, se crea el nuevo producto con el número de parte
                                if (formData.clienteID !== "") {
                                    //Se guarda el producto asociado.                    
                                    var producto = {};
                                    producto.clienteID = formData.clienteID;
                                    producto.numerodeParte = formData.numerodeParte;
                                    producto.descripcion = formData.descripcion;
                                    producto.cotizacionID = formData.id;
                                    producto.divisa = formData.divisa;
                                    producto.precioUnitario = formData.processEngineering !== "Plating Tool" ? formData.finalSQFTPrice : "0";
                                    if (formData.processEngineering !== "Painting Tool") {
                                        producto.precioUnitarioP = formData.finalPSQFTPrice;
                                    }
                                    producto.cantidadporAnio = formData.annualVolume;
                                    producto.piezasXRack = formData.piecesPerRack;
                                    producto.activo = formData.activo;
                                    producto.Reg_Ins_Usuario = userName;

                                    if (formData.documento1) {
                                        producto.documento1 = formData.documento1
                                    }
                                    if (formData.documento2) {
                                        producto.documento2 = formData.documento2
                                    }
                                    if (formData.documento3) {
                                        producto.documento3 = formData.documento3
                                    }
                                    if (formData.documento4) {
                                        producto.documento4 = formData.documento4
                                    }
                                    if (formData.documento5) {
                                        producto.documento5 = formData.documento5
                                    }
                                    setMensajeAlert("Problemas al guardar el producto: " + JSON.stringify(producto));
                                    let productoCreado = await guardarProductos(producto, false, false, {}, {}, true)
                                    if (productoCreado.productoID) {
                                        formData.productoID = productoCreado.productoID;
                                        formData.productoCreado = true;
                                        vproductoCreado = true;
                                    } else {
                                        mensaje = productoCreado.mensaje;
                                        setMensajeAlert("Problemas al guardar el producto: " + JSON.stringify(producto));
                                        return;
                                    }


                                }
                            }

                        }
                        //Se crea una notificación de la creación de la autorización cotización para la persona que creó la cotización.
                        const notificaciones = {
                            modulo: "Cotizaciones",
                            Accion: "Cambio de estatus de la cotización a: " + formData.status,
                            notificacion: "El estatus de la cotización " + formData.quoteNumber + " del cliente " + formData.cliente + " ha cambiado a: " + formData.status,
                            fecha: Moment(new Date()).format("YYYY-MM-DD"),
                            hora: Moment(new Date()).format("HH:mm"),
                            leido: false,
                            usuarioDe: userName,
                            paraSoporte: false,
                            activo: true,
                            Reg_Ins_Usuario: userName
                        };
                        //Se guardan los datos de la notificación.
                        //setMensajeAlert("Error al guardar la notificación general " + JSON.stringify(notificaciones));
                        let resultnot = await API.graphql({ query: createNotificaciones, variables: { input: notificaciones } });
                        //Se crea un registro en la tabla de NotificacionesNuevas para cada uno de los usuarios de soporte
                        notificaciones.NotificacionID = resultnot.data.createNotificaciones.id;
                        const notific = { ...notificaciones, usuarioPara: formData.Reg_Ins_Usuario };
                        //Se establece para qué usuario es la notificación                    
                        //setMensajeAlert("Error al guardar la notificación nueva " + JSON.stringify(notific));
                        await API.graphql({ query: createNotificacionesNuevas, variables: { input: notific } });
                    }
                    formData.Reg_Mod_Usuario = userName;
                    delete formData.createdAt
                    delete formData.updatedAt;
                    delete formData.__typename;
                    delete formData.paginacion;
                    setMensajeAlert("Error al actualizar la cotización " + JSON.stringify(formData));
                    // setMensajeAlert("No se actualizaron las medidas");
                    await API.graphql({ query: updateCotizacion, variables: { input: formData } });
                    //Se actualizan los datos de las medidas del área si así corresponde
                    //Se elimna 
                    if (inputList !== inputListMod || inputList[0].medidaIngresadaEn !== medidaIngresadaEn) {
                        var index = 0;
                        await Promise.all(inputList.map(async (medidas, i) => {
                            if (i < inputList.length - 1) {

                                medidas.medidaIngresadaEn = medidaIngresadaEn;
                                medidas.orden = index;
                                //Si es una actualización
                                if (medidas.id) {
                                    medidas.Reg_Mod_Usuario = userName;
                                    delete medidas.createdAt;
                                    delete medidas.updatedAt;
                                    delete medidas.__typename;
                                    setMensajeAlert("Error al actualizar las medidas del área " + JSON.stringify(medidas));
                                    await API.graphql({ query: updateCotizacionArea, variables: { input: medidas } });
                                } else {//Si es un nuevo registro
                                    medidas.numero = formData.numero;
                                    medidas.idCotizacion = formData.id;
                                    medidas.Reg_Ins_Usuario = userName;
                                    setMensajeAlert("Error al guardar las medidas del área " + JSON.stringify(medidas));
                                    await API.graphql({ query: createCotizacionArea, variables: { input: medidas } });

                                }
                                if (medidas.activo === true) index++;
                            }
                        }))
                    }
                    //Se guarda el archivo 
                    if (formData.documentoAceptacion) {
                        await uploadData({ key: archivo.name, data: archivo });//await Storage.put(archivo.name, archivo);
                    }
                    setMensajeAlert("Operación exitosa,se actualizaron los datos del Quote Number: " + formData.quoteNumber +
                        (clienteCreado === true ? (". También se creó el cliente " + formData.cliente + (vproductoCreado === true ? (" y el número de parte " + formData.numerodeParte) : "") + ".") :
                            (contactoAgregado === true && vproductoCreado === true) ? (". También se agregó el contacto correspondiente para el cliente " +
                                formData.cliente + (" y el número de parte " + formData.numerodeParte)) :
                                vproductoCreado === true ? (" También se creó el número de parte " + formData.numerodeParte) : mensaje));
                    setColor("primary");
                }
                setAVisible(true);
                setCargando(false);
                cancelarCotizacion();
            }

        } catch (e) {
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el problema persiste, favor de comunicarte a sistemas");
            setColor("warning");
            setAVisible(true);
            setCargando(false);
            setisDisabled(false);
        }
    };
    //Maneja los cambios en ls datos de la cotización
    function cambioDeDatos(nombre, valor) {
        const re = /^[0-9\.]+$/;
        //Datos de clientes
        const packingSource = nombre === "cliente" ? valor : formData.packingSource;
        const clienteID = (nombre === "cliente" && editarCliente === true) ? "" : formData.clienteID;
        //Datos del proceso de Platinado        
        const platingProcess = nombre === "platingProcess" ? valor : (nombre === "processEngineering" && valor === "Painting Tool") ? "" : formData.platingProcess;
        const zincPlating = nombre === "zincPlating" ? valor : (nombre === "processEngineering" && valor === "Painting Tool") ? "" : formData.zincPlating;
        //Datos del proceso de pintado.
        const paintThickness = nombre === "paintThickness" ? valor : (nombre === "processEngineering" && valor === "Plating Tool") ? "" : formData.paintThickness;
        const paintSpec = nombre === "paintSpec" ? valor : (nombre === "processEngineering" && valor === "Plating Tool") ? "" : formData.paintSpec;

        //Se obtiene el valor de piecesPerRack       
        const piecesPerRack = nombre === "piecesperBar" ? parseFloat(!valor ? 0 : valor) *
            parseFloat(!formData.barsPerLevel ? 0 : formData.barsPerLevel) * parseFloat(!formData.levels ? 0 : formData.levels) :
            nombre === "barsPerLevel" ? parseFloat(!valor ? 0 : valor) *
                parseFloat(!formData.piecesperBar ? 0 : formData.piecesperBar) * parseFloat(!formData.levels ? 0 : formData.levels) :
                nombre === "levels" ? parseFloat(!valor ? 0 : valor) *
                    parseFloat(!formData.piecesperBar ? 0 : formData.piecesperBar) * parseFloat(!formData.barsPerLevel ? 0 : formData.barsPerLevel) :
                    formData.piecesPerRack

        const weightForRack = nombre === "pieceWeight" ? parseFloat(!valor ? 0 : valor) * parseFloat(!piecesPerRack ? 0 : piecesPerRack) :
            (piecesPerRack != formData.piecesPerRack) ? parseFloat(!formData.pieceWeight ? 0 : formData.pieceWeight) * parseFloat(!piecesPerRack ? 0 : piecesPerRack) :
                formData.weightForRack;


        const finalRackSale = nombre === "finalSalePrice" ? (parseFloat(!valor ? 0 : valor) * parseFloat(!piecesPerRack ? 0 : piecesPerRack)).toFixed(5) :
            nombre === "piecesPerRack" ? (parseFloat(!valor ? 0 : valor) * parseFloat(!formData.finalSalePrice ? 0 : formData.finalSalePrice)).toFixed(5) :
                (piecesPerRack != formData.piecesPerRack) ? (parseFloat(!formData.finalSalePrice ? 0 : formData.finalSalePrice) * parseFloat(!piecesPerRack ? 0 : piecesPerRack)).toFixed(5) :
                    formData.finalRackSale;

        const processSuggestedPrice = piecesPerRack > 0 ? (piecesPerRack / 70).toFixed(5) :
            (nombre === "piecesperBar" || nombre === "barsPerLevel" || nombre === "levels") ? 0 :
                !formData.processSuggestedPrice ? 0 : formData.processSuggestedPrice;


        const totalPerRack = nombre === "processSuggestedPrice" ? (parseFloat(!valor ? 0 : valor) * parseFloat(!piecesPerRack ? 0 : piecesPerRack)).toFixed(5) :
            (piecesPerRack != formData.piecesPerRack) ? (parseFloat(processSuggestedPrice) * parseFloat(!piecesPerRack ? 0 : piecesPerRack)).toFixed(5) :
                formData.totalPerRack;
        const toolingCost = nombre === "annualVolume" ? ((parseFloat(!valor ? 0 : valor) / 52 / 5 / 3) * 3).toFixed(5) :
            formData.toolingCost;

        const maximumPieces = nombre === "area" ? (parseFloat(!valor ? 0 : (250 / valor))).toFixed(5) :
            formData.maximumPieces;

        const totalWeightRack = nombre === "pieceWeight" ? parseFloat(!valor ? 0 : valor) * parseFloat(!piecesPerRack ? 0 : piecesPerRack) :
            (piecesPerRack != formData.piecesPerRack) ? parseFloat(!formData.pieceWeight ? 0 : formData.pieceWeight) * parseFloat(!piecesPerRack ? 0 : piecesPerRack) :
                formData.totalWeightRack;



        const finalSQFTPrice = nombre === "finalSalePrice" ? (parseFloat(!valor ? 0 : valor) / parseFloat(!formData.area ? 0 : formData.area)).toFixed(5) :
            nombre === "area" ? (parseFloat(!formData.finalSalePrice ? 0 : formData.finalSalePrice) / parseFloat(!valor ? 0 : valor)).toFixed(5) :
                formData.finalSQFTPrice;

        const toolingCostP = nombre === "annualVolume" ? (parseFloat(!valor ? 0 : valor) / 52 / 5 / 8).toFixed(5) :
            formData.toolingCostP;

        const SQTFPerBR = nombre === "tPiecesPROB" ? (parseFloat(!valor ? 0 : valor) * parseFloat(!formData.area ? 0 : formData.area)).toFixed(5) :
            nombre === "area" ? (parseFloat(!formData.tPiecesPROB ? 0 : formData.tPiecesPROB) * parseFloat(!valor ? 0 : valor)).toFixed(5) :
                formData.SQTFPerBR;

        /*const processPSuggestedPrice = SQTFPerBR > 0 ? (SQTFPerBR / 70).toFixed(5) :
            (nombre === "tPiecesPROB" || nombre === "pPerlevel" || nombre === "lPerRack") ? 0 :
                !formData.processPSuggestedPrice ? 0 : formData.processPSuggestedPrice;*/

        const processPSuggestedPrice = formData.typeOfProcess !== "" ? nombre === "tPiecesPROB" ? (parseFloat(!valor ? 0 : valor) / (formData.typeOfProcess === "Barrel" ? 40 : 25)).toFixed(5) :
            nombre === "typeOfProcess" ? formData.tPiecesPROB ? formData.tPiecesPROB > 0 ? valor !== "" ? (parseFloat(formData.tPiecesPROB) / (valor === "Barrel" ? 40 : 25)).toFixed(5) : 0 : 0 : 0 :
                nombre === "pieceWeight" ? (parseFloat(!formData.tPiecesPROB ? 0 : formData.tPiecesPROB) * parseFloat(!valor ? 0 : valor)).toFixed(5) : 0 :
            !formData.processPSuggestedPrice ? 0 : formData.processPSuggestedPrice;

        const loadWeightK = nombre === "tPiecesPROB" ? (parseFloat(!valor ? 0 : valor) * parseFloat(!formData.pieceWeight ? 0 : formData.pieceWeight)).toFixed(5) :
            nombre === "pieceWeight" ? (parseFloat(!formData.tPiecesPROB ? 0 : formData.tPiecesPROB) * parseFloat(!valor ? 0 : valor)).toFixed(5) :
                formData.loadWeightK;

        const suggestedRBSale = nombre === "tPiecesPROB" ? (parseFloat(!valor ? 0 : valor) * parseFloat(!processPSuggestedPrice ? 0 : processPSuggestedPrice)).toFixed(5) :
            nombre === "processPSuggestedPrice" ? (parseFloat(!formData.tPiecesPROB ? 0 : formData.tPiecesPROB) * parseFloat(!valor ? 0 : valor)).toFixed(5) :
                formData.suggestedRBSale;

        const finalRBSale = nombre === "tPiecesPROB" ? (parseFloat(!valor ? 0 : valor) * parseFloat(!formData.finalPSalePrice ? 0 : formData.finalPSalePrice)).toFixed(5) :
            nombre === "finalPSalePrice" ? (parseFloat(!formData.tPiecesPROB ? 0 : formData.tPiecesPROB) * parseFloat(!valor ? 0 : valor)).toFixed(5) :
                formData.finalRBSale;

        const finalPSQFTPrice = nombre === "finalPSalePrice" ? (parseFloat(!valor ? 0 : valor) / parseFloat(!formData.area ? 0 : formData.area)).toFixed(5) :
            nombre === "area" ? (parseFloat(!formData.finalPSalePrice ? 0 : formData.finalPSalePrice) / parseFloat(!valor ? 0 : valor)).toFixed(5) :
                formData.finalPSQFTPrice;

        const quoteNumber = nombre === "date" ? valor ? "QUBTI" + Moment(valor).format("MMDDYY") + "-" : "" :
            formData.quoteNumber
        setQuoteNumberO(quoteNumber);
        const numero = (valor === '' || re.test(valor)) ? true : false;

        //if (nombre==="piecesperBar")
        updateFormData(() => ({
            ...formData, [nombre]: valor, platingProcess: platingProcess, zincPlating: zincPlating,
            paintThickness: paintThickness, paintSpec: paintSpec, packingSource: packingSource, clienteID: clienteID,
            processSuggestedPrice: nombre === "processSuggestedPrice" ? numero ? valor : formData.processSuggestedPrice : processSuggestedPrice,
            processPSuggestedPrice: nombre === "processPSuggestedPrice" ? numero ? valor : formData.processPSuggestedPrice : processPSuggestedPrice,
            piecesPerRack: nombre === "piecesPerRack" ? numero ? valor : formData.piecesPerRack : piecesPerRack,
            weightForRack: nombre === "weightForRack" ? numero ? valor : formData.weightForRack : weightForRack,
            totalPerRack: nombre === "totalPerRack" ? numero ? valor : formData.totalPerRack : totalPerRack,
            suggestedRack: nombre === "suggestedRack" ? numero ? valor : formData.suggestedRack : totalPerRack,
            finalRackSale: nombre === "finalRackSale" ? numero ? valor : formData.finalRackSale : finalRackSale,
            toolingCost: nombre === "toolingCost" ? numero ? valor : formData.toolingCost : toolingCost,
            maximumPieces: nombre === "maximumPieces" ? numero ? valor : formData.maximumPieces : maximumPieces,
            totalWeightRack: nombre === "totalWeightRack" ? numero ? valor : formData.totalWeightRack : totalWeightRack,
            finalSQFTPrice: nombre === "finalSQFTPrice" ? numero ? valor : formData.finalSQFTPrice : finalSQFTPrice,
            toolingCostP: nombre === "toolingCostP" ? numero ? valor : formData.toolingCostP : toolingCostP,
            SQTFPerBR: nombre === "SQTFPerBR" ? numero ? valor : formData.SQTFPerBR : SQTFPerBR,
            loadWeightK: nombre === "loadWeightK" ? numero ? valor : formData.loadWeightK : loadWeightK,
            suggestedRBSale: nombre === "suggestedRBSale" ? numero ? valor : formData.suggestedRBSale : suggestedRBSale,
            finalRBSale: nombre === "finalRBSale" ? numero ? valor : formData.finalRBSale : finalRBSale,
            finalPSQFTPrice: nombre === "finalPSQFTPrice" ? numero ? valor : formData.finalPSQFTPrice : finalPSQFTPrice,
            quoteNumber: nombre === "quoteNumber" ? numero ? valor : formData.quoteNumber : quoteNumber
        }));
    }
    //Llama a la función que maneja los cambios en ls datos de la cotización
    function onChanges(e) {
        cambioDeDatos(e.target.name, e.target.value);
        if (e.target.name === "status" && e.target.value === "Accepted") {
            toggle2();
        }
        if (e.target.name === "status" && e.target.value === "Rejected") {
            toggle3();
        }
        if (e.target.name === "numerodeParte") {
            setisDisabled(false);
            setAVisible(false);
            const cotiRech = cotizacionesRechazadas.filter(cotizacion =>
                cotizacion.numerodeParte === e.target.value && formData.id != cotizacion.id)
            if (cotiRech.length > 0) {
                window.scrollTo(0, 0);
                setAVisible(true);
                setMensajeAlert("Ya existe una cotización rechazada con dicho número de parte," +
                    " se tiene que modificar la cotización ");
                setisDisabled(true);
            }
        }
    }
    function onChangesNumeros(e) {
        const re = /^[0-9\.]+$/;

        if (e.target.value === '' || re.test(e.target.value)) {
            cambioDeDatos(e.target.name, e.target.value);
        }
    }
    //Revisa cambios en la fecha de búsqueda
    function onChangesRFechaini(e) {
        e.persist()
        var fechaini = rfechaini;
        var fechafin = rfechafin;
        if (e.target.name === "rfechaini") {
            fechaini = e.target.value;
        } else {
            fechafin = e.target.value;
        }
        setRfechafin(fechafin);
        setRfechaini(fechaini);
        fetchCotizaciones(fechaini, fechafin);

    }
    //Revisa cambios en el input de clientes
    function onChangesClientes(e) {
        e.persist()
        cambioClientes(e.target.value, formData, false);
    }
    //Revisa cambios en el input de clientes
    async function cambioClientes(clienteID, data, preparando) {
        if (clienteID != "") {
            const valor = clienteID;
            const fClienteID = valor;//valor.substr(0, valor.search('(&g&)') - 1);
            const ClienteDato = clientes.filter(dCliente => dCliente.id === fClienteID)
            const fCliente = ClienteDato[0].cliente;//valor.substr(valor.search('(&g&)') + 4, valor.length);
            const address = ClienteDato[0].domicilio;
            const colonia = ClienteDato[0].colonia;
            const ciudad = ClienteDato[0].ciudad;
            const estado = ClienteDato[0].estado
            const pais = ClienteDato[0].pais
            const codigoPostal = ClienteDato[0].codigoPostal;
            const telefono = ClienteDato[0].telefono;
            const correo = ClienteDato[0].correo;
            var contactos = [];
            if (ClienteDato[0].nombreContacto) {
                contactos.push({
                    requestor: ClienteDato[0].nombreContacto, position: ClienteDato[0].puestoContacto, desk: ClienteDato[0].telefono,
                    mobile: ClienteDato[0].telefonoContacto, email: ClienteDato[0].correoContacto
                });
            }
            if (ClienteDato[0].nombreContacto1) {
                contactos.push({
                    requestor: ClienteDato[0].nombreContacto1, position: ClienteDato[0].puestoContacto1, desk: ClienteDato[0].telefono,
                    mobile: ClienteDato[0].telefonoContacto1, email: ClienteDato[0].correoContacto1
                });
            }
            if (ClienteDato[0].nombreContacto2) {
                contactos.push({
                    requestor: ClienteDato[0].nombreContacto2, position: ClienteDato[0].puestoContacto2, desk: ClienteDato[0].telefono,
                    mobile: ClienteDato[0].telefonoContacto2, email: ClienteDato[0].correoContacto2
                });
            }
            if (ClienteDato[0].nombreContacto3) {
                contactos.push({
                    requestor: ClienteDato[0].nombreContacto3, position: ClienteDato[0].puestoContacto3, desk: ClienteDato[0].telefono,
                    mobile: ClienteDato[0].telefonoContacto3, email: ClienteDato[0].correoContacto3
                });
            }
            if (ClienteDato[0].nombreContacto4) {
                contactos.push({
                    requestor: ClienteDato[0].nombreContacto4, position: ClienteDato[0].puestoContacto4, desk: ClienteDato[0].telefono,
                    mobile: ClienteDato[0].telefonoContacto4, email: ClienteDato[0].correoContacto4
                });
            }
            if (contactos.length >= 5) {
                const contactosc = await GetClienteContactos({ clienteID: { eq: fClienteID } });
                await Promise.all(contactosc.map(async contacto => {
                    contactos.push({
                        requestor: contacto.nombreContacto, position: contacto.puestoContacto, desk: contacto.telefono,
                        mobile: contacto.telefonoContacto, email: contacto.correoContacto
                    });
                }))
            }
            if (preparando === true) {
                updateFormData(() => ({
                    ...data, ["clienteID"]: fClienteID, ["cliente"]: fCliente, ["address"]: address, ["colonia"]: colonia,
                    ["ciudad"]: ciudad, ["estado"]: estado, ["pais"]: pais, ["codigoPostal"]: codigoPostal,
                    ["telefono"]: telefono, ["correo"]: correo, ["packingSource"]: fCliente
                }));
            } else {
                updateFormData(() => ({
                    ...data, ["clienteID"]: fClienteID, ["cliente"]: fCliente, ["address"]: address, ["colonia"]: colonia,
                    ["ciudad"]: ciudad, ["estado"]: estado, ["pais"]: pais, ["codigoPostal"]: codigoPostal,
                    ["telefono"]: telefono, ["correo"]: correo, ["requestor"]: "", ["position"]: "", ["desk"]: "",
                    ["mobile"]: "", ["email"]: "", ["packingSource"]: fCliente
                }));

            }
            setRequestors(contactos);
        } else {
            if (preparando === false) {
                updateFormData(() => ({
                    ...data, ["clienteID"]: "", ["cliente"]: "", ["address"]: "", ["colonia"]: "",
                    ["ciudad"]: "", ["estado"]: "", ["pais"]: "", ["codigoPostal"]: "",
                    ["telefono"]: "", ["correo"]: "", ["packingSource"]: "",
                    ["requestor"]: "", ["position"]: "", ["desk"]: "", ["mobile"]: "", ["email"]: ""
                }));
            } else {
                updateFormData(() => ({ ...data }));
            }
            setRequestors([]);
        }
    }
    function onChangesRequestor(e) {
        e.persist()
        if (e.target.value != "") {
            const valor = e.target.value;
            const contactos = requestors.filter(requestor => requestor.requestor === valor)
            updateFormData(() => ({
                ...formData, ["requestor"]: contactos[0].requestor, ["position"]: contactos[0].position, ["desk"]: contactos[0].desk,
                ["mobile"]: contactos[0].mobile, ["email"]: contactos[0].email
            }));
        } else {
            updateFormData(() => ({
                ...formData, ["requestor"]: "", ["position"]: "", ["desk"]: "", ["mobile"]: "", ["email"]: ""
            }));
        }
    }
    function onChangeMedidaEn(e) {
        setMedidaIngresadaEn(e.target.value);
        calcularArea(inputList, e.target.value);

    }
    function handleInputChangeMedidas(e, index, list) {
        const re = /^[0-9\.]+$/;

        if (e.target.value === '' || re.test(e.target.value)) {
            return handleInputDatos(e, index, list)
        } else {
            return list;
        }

    };
    async function ObtenerDocumento(ndocumento, documento, ncampo) {
        if (ndocumento) {
            const fimagen = await getUrl({ key: ndocumento });//await Storage.get(ndocumento);
            updateFormData(() => ({ ...formData, [documento]: fimagen.url.toString(), [ncampo]: ndocumento }));
        }
    }
    //Se revisa si el archivo seleccionado ya existe en la base de datos    
    async function onChangelogodoc(e) {
        setCargando(true);
        setAVisible(false);
        const file = e.target.files[0];
        const documentesxists = await list({ path: file.name });// await Storage.list(file.name);
        updateFormData(() => ({ ...formData, [e.target.name]: file.name }));
        if (documentesxists.length === 0) {
            setCargando(false);
            //await Storage.put(file.name, file);
            await uploadData({ key: file.name, data: file });
        } else {
            setMensajeAlert("Ya existe un archivo con el mismo nombre: si requiere agregar un nuevo archivo, cambie el nombre y vuelva a seleccionarlo.");
            setColor("info");
            setCargando(false);
            setAVisible(true);
            window.scrollTo(0, 0);
        }
    }
    //Se revisa si el archivo seleccionado ya existe en la base de datos
    async function onChangedocumento(e) {
        setCargandoM(true);
        setAVisibleM(false);
        window.scrollTo(0, 0);
        setDocumentoRepetido(true);
        const file = e.target.files[0];
        const documentesxists = await list({ path: file.name });//await Storage.list(file.name);
        if (documentesxists.length === 0) {
            setDocumentoRepetido(false);
            setAVisibleM(false);
            setArchivo(file);
            setCargandoM(false);
            updateFormData(() => ({ ...formData, [e.target.name]: file.name }));
        } else {
            setDocumentoRepetido(true);
            setMensajeAlertM("Ya existe un archivo con el mismo nombre: favor de seleccionar otro archivo o cambiar el nombre y volver a intentarlo: ");
            setArchivo({});
            setColorM("warning");
            setCargandoM(false);
            setAVisibleM(true);
            window.scrollTo(0, 0);
        }
    }

    //Función que revisa los cambios en los datos del cálculo del área.
    function handleInputDatos(e, index, list) {

        const { name, value } = e.target;

        var listaResult = list.map((medida, i) => {
            if (i !== index) {
                // No hay cambios
                return medida;
            } else {
                // Regresa el dato con el valor de activo igual a falso
                return {
                    ...medida,
                    [name]: value
                };
            }
        });

        if ((index + 1) === list.length) {
            listaResult = [...listaResult, initialArea]
        }
        //Se calcula el área con las medidas obtenidas
        calcularArea(listaResult, medidaIngresadaEn);


        return listaResult;
    };
    function calcularArea(list, medidasEn) {
        var area = 0;
        //Se obtiene el área de cada medida ingresada y se multiplica por 2
        list.map((medidas) => {
            if (medidas.alto !== "" && medidas.ancho !== "" && medidas.activo === true) {
                area = area + (((parseFloat(medidas.alto) * parseFloat(medidas.ancho)) * 2) * medidas.repeticiones)
            }
            return medidas
        })
        //Se revisa si las medidas ingresadas están en milímetros o pulgadas, y se convierte a pies.
        if (medidasEn === "Milímetros") {
            area = area * 0.000010764;
        } else {
            if (medidasEn === "Pulgadas") {
                area = area / 144;
            } else {//Centímetros
                area = (area / 2.54);
            }
        }
        //Se actualiza el valor del área
        cambioDeDatos("area", area.toFixed(5));
    }
    function handleRemoveClick(index, list) {
        var listaResult = [];
        if (!list[index].id) {
            listaResult = list.filter(medida => medida !== list[index])
            list.splice(index, 1);
        } else {
            listaResult = list.map((medida, i) => {
                if (i !== index) {
                    // No hay cambios
                    return medida;
                } else {
                    // Regresa el dato con el valor de activo igual a falso
                    return {
                        ...medida,
                        activo: false
                    };
                }
            });
        }

        calcularArea(listaResult, medidaIngresadaEn);

        return listaResult;

    };
    async function cancelarMedidas() {
        if (!editar) {
            setMedidaIngresadaEn("Milímetros");
            setInputList([initialArea]);
            updateFormData(() => ({
                ...formData, "area": ""
            }));
        } else {
            setInputList(inputListMod);
            calcularArea(inputListMod, inputListMod[0].medidaIngresadaEn);
            setMedidaIngresadaEn(inputListMod[0].medidaIngresadaEn);
        }
        toggle();
    }
    async function cancelarRechazo() {
        toggle3();
        const datos = await GetCotizacionID(formData.id);
        updateFormData(datos);
    }
    return {
        pcotizaciones,
        permisoAutorizar,
        color,
        aVisible,
        mensajeAlert,
        cargando,
        activeTab,
        searchBy,
        search,
        tituloTab,
        rfechaini,
        rfechafin,
        cotizaciones,
        currentPageCotizaciones,
        ultimoNumeroP,
        paginas,
        clientes,
        formData,
        editar,
        faltanDatos,
        requestors,
        inputList,
        isDisabled,
        componentRef,
        cotizacionImprimir,
        formType,
        modal,
        medidaIngresadaEn,
        inputListMod,
        editarCliente,
        editarContacto,
        editarPprocess,
        editarAToolBar,
        modal2,
        modal3,
        clienteNuevo,
        contactoNuevo,
        productoNuevo,
        archivo,
        cargandoM,
        aVisibleM,
        colorM,
        mensajeAlertM,
        hEditarCotizacion,
        cotizacionesRechazadas,
        statusOriginal,
        documenton,
        setDocumenton,
        toggle3,
        cancelarRechazo,
        setClienteNuevo,
        setContactoNuevo,
        setProductoNuevo,
        setEditarContacto,
        setEditarPprocess,
        setEditarAToolBar,
        setEditarCliente,
        onChangeMedidaEn,
        handleRemoveClick,
        cancelarMedidas,
        handleInputChangeMedidas,
        handleInputDatos,
        setMedidaIngresadaEn,
        setInputList,
        toggle2,
        onChangedocumento,
        onChangelogodoc,
        toggle,
        clicNuevaCotizacion,
        buscarpor,
        onDismiss,
        setSearch,
        onSearchFecha,
        onChangesRFechaini,
        onSearch,
        toggle1,
        fetchCotizaciones,
        clicMostrar,
        clicEditar,
        clicAutorizar,
        setCotizacionImprimir,
        clicAgregarCotizacion,
        actualizarStatusCotizacion,
        handlePrint,
        handlePageChangeCotizaciones,
        onChanges,
        onChangesNumeros,
        onChangesClientes,
        onChangesRequestor,
        cancelarCotizacion,
        cancelarModalCotizacion,
        manageCotizacion
    }
}
